import { useContext } from "react";
import { ApplicationContext } from "./ApplicationContext";

export const useAuth = () => {
  const auth = useContext(ApplicationContext);

  return auth;
};
